<template>
  <v-form @submit.prevent="save">
    <span class="text-subtitle-1">Laudo Externo</span>
    <v-select
      v-model="type"
      :items="types"
      item-text="label"
      item-value="value"
      label="Tipo"
      dense
      outlined
      clearable
      class="mt-3"
    ></v-select>
    <template v-if="type === 'leorad'">
      <v-switch
        v-model="leorad.enable"
        label="Ativo"
        color="primary"
        class="mt-0 mb-2"
      ></v-switch>
      <v-switch
        v-model="leorad.auto"
        label="Executa ao criar novo laudo"
        color="primary"
        class="mt-0 mb-2"
      ></v-switch>
      <v-text-field
        v-model="leorad.token"
        label="Token"
        dense
        outlined
      ></v-text-field>
    </template>
    <template v-if="type === 'laudite'">
      <v-switch
        v-model="laudite.enable"
        label="Ativo"
        color="primary"
        class="mt-0 mb-2"
      ></v-switch>
      <v-switch
        v-model="laudite.auto"
        label="Executa ao criar novo laudo"
        color="primary"
        class="mt-0 mb-2"
      ></v-switch>
      <v-text-field
        v-model="laudite.email"
        label="E-mail"
        dense
        outlined
      ></v-text-field>
      <v-text-field
        v-model="laudite.company_id"
        label="Company ID"
        dense
        outlined
      ></v-text-field>
    </template>
  </v-form>
</template>
<script>
import Api from '@/resources/NajaSocialApi'
import Setting from '@/helpers/setting'
export default {
  name: 'ExternalReportForm',
  data: () => ({
    loading: false,
    user: {
      name: null,
      id: null,
      user_id: null,
    },
    types: [
      { label: 'LeoRad', value: 'leorad' },
      { label: 'Laudite', value: 'laudite' },
    ],
    type: null,
    leorad: {
      enable: false,
      auto: false,
      token: null,
    },
    laudite: {
      enable: false,
      auto: false,
      email: null,
      company_id: null,
    },
  }),
  methods: {
    clearForm() {
      this.loading = false
      this.user = { id: null, name: null, user_id: null }
      this.type = null
      this.leorad = { enable: false, auto: false, token: null }
      this.laudite = { enable: false, auto: false, email: null, company_id: null }
    },

    setForm(user, externalReportType, leoradData, lauditeData) {
      this.user = user
      this.type = externalReportType || null

      if (leoradData) {
        this.leorad = {
          enable: leoradData.enable || false,
          auto: leoradData.auto || false,
          token: leoradData.token || null,
        }
      }

      if (lauditeData) {
        this.laudite = {
          enable: lauditeData.enable || false,
          auto: lauditeData.auto || false,
          email: lauditeData.email || null,
          company_id: lauditeData.company_id || null,
        }
      }
    },

    save() {
      if (!this.type) {
        this.$root.$children[0].toast('Selecione o tipo de laudo externo')
        return
      }

      this.loading = true

      let payload
      if (this.type === 'leorad') {
        payload = { user: { external_report_type: 'leorad', credentials_for_leorad: Setting.reverse(this.leorad) } }
      } else {
        payload = { user: { external_report_type: 'laudite', credentials_for_laudite: Setting.reverse(this.laudite) } }
      }

      Api.users
        .save(this.user.user_id, payload)
        .then(() => {
          this.$root.$children[0].toast('Configuração salva com sucesso')
        })
        .catch(error => {
          if (error.response) {
            this.$root.$children[0].toast('Erro ao salvar configuração')
          } else {
            throw error
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
